import styles from './Spinner.module.css';
interface props {
  widthFull?: string;
}

export const Spinner = ({ widthFull }: props) => {
  return (
    <div className={`${styles.spinnerContainer}  ${widthFull}`}>
      <div className={styles.loader}></div>
    </div>
  );
};
